<h5 class="title mb-3 text-primary">{{'verificacao_method'|translate}}</h5>
<p>{{'verificacao_security_reasons'|translate}}</p>
<ul class="row g-3">
    <li *ngFor="let method of mdcService.metodoVerificacao; let i = index; let first = first; let last = last; let even = even; let odd = odd"
        [ngClass]="even && last ? 'col-sm' : 'col-sm-6'">

        <div class="custom-control custom-control-sm custom-radio pro-control custom-control-full">
            <input type="radio" class="custom-control-input" name="'two-FA-method'" id="{{method.code}}"
                value="{{method.value}}" [(ngModel)]="mdcService.selectedMethod"
                [attr.data-msg]="('obrigatorio_error_msg' | translate)" required />
            <label class="custom-control-label" for="{{method.code}}">
                <span class="d-flex flex-column text-center">
                    <span class="icon-wrap xl text-primary">
                        <app-email-icon *ngIf="method.icon === 'email-icon'"></app-email-icon>
                        <app-sms-icon *ngIf="method.icon === 'sms-icon'"></app-sms-icon>
                        <app-qrcode-icon *ngIf="method.icon === 'qrcode-icon'"></app-qrcode-icon>
                        <app-captcha-icon *ngIf="method.icon === 'captcha-icon'"></app-captcha-icon>
                    </span>
                    <span class="lead-text mb-1 mt-3">{{i + 1 }} - {{ method.lable | translate }}</span>
                    <span *ngIf="method.code === 'two-FA-QR-Code'" class="sub-text">
                        {{ 'verificacao_qrcode_2' | translate }}
                    </span>
                    <span *ngIf="method.code === 'two-FA-Captcha'" class="sub-text">
                        {{'verificacao_captcha_2' |translate}}
                    </span>
                </span>
            </label>
        </div>
    </li>
</ul>
<div class="row g-3 mt-4">
    <div class="col-12" *ngIf="mdcService.selectedMethod === 'email'">
        <div class="form-group">
            <label class="form-label" for="cp-email-code">1. {{'verificacao_email_label'|translate}}</label>
            <div class="form-control-wrap">
                <input [(ngModel)]="mdcService.email" type="email" class="form-control" id="cp-email-code"
                    name="cp-app-code" placeholder="email@mdc.com"
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
            </div>
        </div>
    </div>
    <div class="col-12" *ngIf="mdcService.selectedMethod === 'sms'">
        <div class="form-group">
            <label class="form-label" for="cp-sms-code">2. {{'verificacao_sms_label'|translate}}</label>
            <div class="form-control-wrap">
                <input [(ngModel)]="mdcService.phoneNumber" type="tel" class="form-control" id="cp-sms-code"
                    name="cp-app-code" placeholder="+235 9999999"
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
            </div>
        </div>
    </div>
</div>